import { render, staticRenderFns } from "./DettaglioBacheca.vue?vue&type=template&id=d38af412&"
import script from "./DettaglioBacheca.vue?vue&type=script&lang=js&"
export * from "./DettaglioBacheca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports